import React from 'react';

export const successIcon = (<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path
    d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48
    17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20
    12C20 16.41 16.41 20 12 20ZM16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z"
    fill="#07862C"
  />
</svg>);

export const warningIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20" fill="none">
    <path d="M11 4.49L18.53 17.5H3.47L11 4.49ZM11 0.5L0 19.5H22L11 0.5ZM12 14.5H10V16.5H12V14.5ZM12 8.5H10V12.5H12V8.5Z" fill="#A87000" />
  </svg>
);

export const errorIcon = (<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path
    d="M11 15H13V17H11V15ZM11 7H13V13H11V7ZM11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22
    11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4
    12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z"
    fill="#B50000"
  />
</svg>);

export const closeIcon = (<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path
    d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
    fill="#767676"
  />
</svg>);

export const successCloseIcon = (<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path
    d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
    fill="#07862C"
  />
</svg>);

export const errorCloseIcon = (<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path
    d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
    fill="#B50000"
  />
</svg>);
